export enum SubmissionStatus {
  ALREADY_FILED = "already_filed",
  COMPLETED = "completed",
  ERROR = "error",
  IN_PROGRESS = "in_progress",
  PAYER_NOT_SUPPORTED = "payer_not_supported",
}
